import { Component, Input, OnInit } from '@angular/core';
import { JardinExtraData } from 'src/app/model/ReglamentoInterno.model';

@Component({
  selector: 'app-identificacion-antecedentes',
  templateUrl: './identificacion-antecedentes.component.html',
  styleUrls: ['./identificacion-antecedentes.component.css']
})
export class IdentificacionAntecedentesComponent implements OnInit {

  @Input() jardinPeriodo : any;
  @Input() jardinExtraData : JardinExtraData;
  @Input() readonly : boolean;

  fechaClass : string = "input-fecha";
  fechaData : any;

  constructor() { }

  ngOnInit(): void {
    this.cargaInicial();
  }

  cargaInicial(){
    var fechaInicioMedicion =  this.jardinExtraData.rroFecha ? new Date(this.jardinExtraData.rroFecha) : null;
    if (fechaInicioMedicion != null) {
      this.fechaData  = {"day": fechaInicioMedicion.getDate(), "month": fechaInicioMedicion.getMonth() + 1, "year": fechaInicioMedicion.getFullYear()};
    }
  }


  change(){
    if( this.fechaData != undefined && this.fechaData != null){
      this.jardinExtraData.rroFecha = new Date(this.fechaData.year, this.fechaData.month -1, this.fechaData.day);;
    }
  }

  clearDate(){
    this.jardinExtraData.rroFecha = null;
    this.fechaData = "";
  }
}
